import base62 from 'base62';
import padLeft from './padLeft';

const createPad = (length) => new Array(length).join('0');

export default (length) => {
    const randomVal = Math.floor(Math.random() * Math.pow(62, length));
    return padLeft(base62.encode(randomVal), createPad(length));
};
